import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import classes from './pages.module.css'
import bigLogo from '../image/logo_big.png';
import arrowDown from '../image/arrow_white.gif';
import img1 from '../image/text_item1.png';
import img2 from '../image/text_item2.png';
import img3 from '../image/text_item3.png';
import logo from '../image/pt_bg.png';
import imgblock1 from '../image/imgBlock1.png';
import imgblock2 from '../image/imgBlock2.jpeg';
import imgblock3 from '../image/imgBlock3.png';
import imgblock4 from '../image/imgBlock4.png';
import linkImg from '../image/linkblock1.png';
import linkImg2 from '../image/linkblock2.png';
import TextItem from '../components/Ui/text/textItem';
import TextFull from '../components/Ui/text/textFull';
import TextList from '../components/Ui/text/textList';
import LinkList from '../components/Ui/block/linkList';
import Tower from './Tower';
import Tele from './Tele';
import ImgList from '../components/Ui/img/imgList';
import SiteLink from '../components/Ui/button/siteLink';
import Acts from './Acts';
import NewsList from '../components/Ui/block/newsList';
import news1 from '../image/news1.png';
import news2 from '../image/news2.png';
import news3 from '../image/news3.png';
import { Container } from 'react-bootstrap';


const Home = () => {
    const [posts, setPosts] = useState([
        {id:1, body: 'Стратегия компании «Пилот Телеком» полностью отвечает целям и требованиям государственной политики, содержащейся в нормативных документах.' },
        {id:2, body: 'Произведенное на предприятии оборудование соответствует требованиям государственной политики импортозамещения радиоэлектронной продукции.' },
        {id:3, body: 'Компания «Пилот Телеком» выстроила высокоинтегрированную инфраструктуру, начиная от производства комплектующих, сборки, до организации логистики и дистрибуции оборудования.' }
    ])
    const [blocks, setBlocks] = useState([
        {id:1, title: 'БАШЕННЫЕ КОНСТРУКЦИИ В УМНОЙ ГОРОДСКОЙ СРЕДЕ', linkImg: (linkImg), linkto: '/tower'},
        {id:2, title: 'ТЕЛЕКОММУНИКАЦИОННЫЕ СИСТЕМЫ', linkImg: (linkImg2), linkto: '/tele' },
    ])
    const [imgblocks, setimgblocks] = useState([
        {id:1, title: 'Нефтегаз', img: (imgblock1)},
        {id:2, title: 'Государственный сектор', img: (imgblock2)},
        {id:3, title: 'Электроэнергетика', img: (imgblock3)},
        {id:4, title: 'Операторы связи', img: (imgblock4)},
    ])
    const [lists, setlists] = useState([
        
    ])
    const [newsitems, setnewsitems] = useState([
        {id:1, img: (news1), title:'В России протестируют новый диапазон для 5G', body: 'Госпредприятие НИИР получило разрешение на тестирование частот в новом диапазоне 6,7—6,8 ГГц. Данный диапазон может помочь решить проблемы с недоступностью в России частот для 5G. Однако пока он не стандартизирован для...', url: 'https://www.cnews.ru/news/top/2021-08-11_v_rossii_protestiruyut_novyj', text: 'Подробнее' },
        {id:2, img: (news2), title:'Число пользователей роуминга 5G к 2026 году превысит 200 млн', body: 'Согласно результатам нового исследования, проведённого сотрудниками аналитической компании Juniper Research, количество абонентов сетей 5G, использующих роуминг, увеличится с 4,5 млн в 2021 году до 210 млн в 2026 году. По словам аналитиков...', url:'https://www.ixbt.com/news/2021/07/26/5g-2026-200.html', text: 'Подробнее' },
        {id:3, img: (news3), title:'Tele2 модернизировала в Петербурге сеть 5G Ready', body: 'Tele2, альтернативный оператор мобильной связи, за полгода расширил зону охвата и увеличил емкость высокоскоростного мобильного интернета в наиболее трафиковых зонах Петербурга. Оператор развивает свою сеть на самом современном...', url: 'https://www.comnews.ru/content/215863/2021-08-09/2021-w32/tele2-modernizirovala-peterburge-set-5g-ready', text: 'Подробнее' }
    ])
    return (
        <>
            <div className={classes.topBlock}>
                <Container fluid="md">
                    <div className={classes.topBlock_content}>
                        <div className={classes.topBlock_body}> 
                            <img 
                                src={bigLogo}
                                className={classes.bigLogo}
                                alt="logo"
                            />
                            <div className={classes.topBlock_text}>
                                <h3>Пилот Телеком - реализует проект по производству отечественного оборудования нового поколения для транспортных телекоммуникационных сетей операторов связи и технологических сетей.</h3>
                            </div>
                            <button className={classes.arrowDown}><img src={arrowDown} /></button>
                        </div>
                        <div className={classes.textBlock}>
                            <TextItem url={img1} alt={'icon'} post={{title: 'Улучшенная производительность сети', body: 'Радиорелейные станции имеют повышенную пропускную способность за счет увеличения плотности потоков и пропускной способности, что способствует продвижению 5 G - пятому поколению мобильной связи.'}} />
                            <TextItem url={img2} alt={'icon'} post={{title: 'Повышение эффективности', body: 'Применение современных оптических мультиплексоров позволит снизить потребление электроэнергии и повысить эффективность использования оптоволокна. Наши мультиплексоры имеют меньший размер, что увеличивает плотность размещаемого оборудования в стойках.'}}/>
                            <TextItem url={img3} alt={'icon'} post={{title: 'Широкая функциональность башенных конструкций', body: 'Современные башенные конструкции - универсальные конструкции модульного типа, относящиеся к инфраструктуре транспортной сети. Имеют привлекательный дизайн, широкий функционал: от размещения оборудования 3-5G для нескольких сотовых операторов, систем видеонаблюдения до интерактивных рекламных площадей.' }}/>
                        </div>
                    </div>
                </Container>
                <div className={classes.bgBlock}></div>
            </div>
            <TextFull text={{
                title: 'О проекте', 
                title2: 'Проект представляет собой комплекс инновационных технологий, направленных на развитие и повышение эффективности функционирования телекоммуникационных сетей и выпуск импортозамещающей продукции.', 
                body: 'Пилот Телеком, владея исключительными правами на современные технологические решения в сегментах радиорелейных станций и оптических мультиплексоров, развивает отечественное производство, обслуживание и модернизацию телекоммуникационного оборудования нового поколения.',
                body2: 'Проект включает производство цифрового радиорелейного оборудования, оптических мультиплексоров нового поколения для транспортных телекоммуникационных сетей операторов связи и технологических сетей, а также производство башенных конструкций для размещения оборудования нескольких сотовых операторов.'
            }} lists={lists} />
            <LinkList blocks={blocks} logo={logo} />
            <ImgList imgblocks={imgblocks} title="Отрасли"/>
            <TextList posts={posts} title="Проект в контексте соответствия национальным интересам" />
            <SiteLink link='/acts' title="Нормативные акты"/>
            <NewsList newsitems={newsitems} title="Новости" />
            <Routes>
                <Route path="/tower" element={<Tower />} />
                <Route path="/tele" element={<Tele />} />
                <Route path="/acts" element={<Acts />} />
            </Routes>
        </>
    )
}

export default Home;